






















































































































































import { JournalEntry } from "../../models/JournalEntry";
import AttachmentsDropdown from "../partials/AttachmentsDropdown.vue";
import EntryValidationCheckbox from "./EntryValidationCheckbox.vue";
import EAttachmentType = JournalEntry.EAttachmentType;
import PhotosViewer from "../../core/Files/PhotosViewer.vue";
import JournalCommentStatusIndicator from "./JournalCommentStatusIndicator.vue";

export default {
    name: "InternalComment",
    components: {
        JournalCommentStatusIndicator,
        PhotosViewer,
        EntryValidationCheckbox,
        AttachmentsDropdown,
    },
    props: {
        entry: JournalEntry,
    },
    data() {
        return {
            absenceModal: {
                absenceId: null,
            },
            localEntry: this.entry,
        };
    },
    methods: {
        sendNotification(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.send_notification,
                this.entry
            );
        },
        requestIntervention(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.intervention_request,
                this.entry
            );
        },
        createIntervention(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.create_intervention,
                this.entry
            );
        },
        openMails(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.show_mails,
                this.entry
            );
        },
        sendEmail(): void {
            if (this.attachementIsAudit()) {
                this.$emit(
                    "action",
                    JournalEntry.UIActionType.send_signalement,
                    this.entry
                );
            } else {
                this.$emit(
                    "action",
                    JournalEntry.UIActionType.send_email,
                    this.entry
                );
            }
        },
        editAbsence(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.edit_absence,
                this.entry
            );
        },
        editFacturation(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.edit_facturation,
                this.entry
            );
        },
        editEntry(): void {
            if (this.attachementIsAudit()) {
                this.$emit(
                    "action",
                    JournalEntry.UIActionType.show_evenement,
                    this.entry
                );
            } else {
                this.$emit(
                    "action",
                    JournalEntry.UIActionType.edit_entry,
                    this.entry
                );
            }
        },
        deleteEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.delete_entry,
                this.entry
            );
        },
        moveEntry(): void {
            this.$emit(
                "action",
                JournalEntry.UIActionType.move_entry,
                this.entry
            );
        },
        // Une ligne dont l'absence est en corbeille (ou supprimée) n'a plus
        // d'absence attachée : elle se comporte comme un commentaire simple.
        attachmentIsAbsence(): boolean {
            return (
                this.entry.attachment_type === EAttachmentType.Absence &&
                !!this.entry.attachment
            );
        },
        attachmentIsFacturation(): boolean {
            return this.entry.attachment_type === EAttachmentType.Facturation;
        },
        // Une ligne dont l'audit est en corbeille (ou supprimé) n'a plus
        // d'évènement attaché : elle se comporte comme un commentaire simple.
        attachementIsAudit(): boolean {
            return (
                this.entry.attachment_type === EAttachmentType.Audit &&
                !!this.entry.attachment
            );
        },
    },
};
